import type { ReactNode } from "react";

export interface MetaRowProps {
  k: ReactNode;
  v: ReactNode;
  mono?: boolean;
}

export function MetaRow({ k, v, mono = false }: MetaRowProps) {
  return (
    <div className="grid grid-cols-[110px_1fr] gap-4 py-2 border-b border-[var(--rule-2)]">
      <span className="caption pt-0.5">{k}</span>
      <span className={`${mono ? "mono text-[12.5px]" : "text-[13.5px]"} text-[var(--ink)]`}>
        {v}
      </span>
    </div>
  );
}
